// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1NpEs","right":"Footer_right__3Viz-","buttons":"Footer_buttons__16mvH"};